"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1613))
 * @trackcomponent
 * @donotsync Syncing adds default color (@quinlan.sokol)
 * @optimized using svgo:^3.0.2
 */
export const Truck = createSVGIcon(
  <>
    <path
      d="M21 18a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM7 18a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 18h1.5a1 1 0 0 0 1-1v-3.985a1 1 0 0 0-.419-.815L20 11l-.811-4.243a1 1 0 0 0-.97-.757H14.5V5a1 1 0 0 0-1-1h-12a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1H3M17 18H7M14.5 6v10M23.5 15H22M20 11h-5.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Truck",
  { viewBox: "0 0 24 24", fill: "none" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
